export const DS_POPOVER_CLASSES = {
  Popover: "ds-popover",
} as const;
